// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e1-a";
export var fulfillmentFormRail = "_e1-9";
export var headerTitleRow = "_e1-c";
export var orderDetailsWrapper = "_e1-7";
export var orderLinkTrigger = "_e1-2";
export var paymentInformationGrid = "_e1-h";
export var paymentSummaryColumn = "_e1-i";
export var shipmentContainer = "_e1-b";
export var shipmentDetailsMainPane = "_e1-8";
export var shipmentNavigationCard = "_e1-5";
export var shipmentNavigationRail = "_e1-3";
export var shipmentNavigationRailHeader = "_e1-4";
export var shipmentSummaryFact = "_e1-e";
export var shipmentSummaryGrid = "_e1-d";
export var shipmentSummaryMetadataRow = "_e1-f";
export var shipmentSummaryTags = "_e1-g";
export var shipmentWorkspace = "_e1-0";
export var shipmentWorkspaceContent = "_e1-6";
export var shipmentWorkspaceHeader = "_e1-1";